export default __webpack_public_path__ + "static/bannerhero-bg-right-16ed875198e869f8e49bb198ad635647.png";